<template>
  <a-layout-header class="header">
    <div class="logo">
      <router-link to="/">
        <img src="../../public/logo.jpg" alt="logo" v-show="isEnglish">
        <img src="../../public/logo.png" alt="logo" v-show="!isEnglish">
      </router-link>
    </div>
    <div class="mobile-menu">
      <div class="m-language">
        <span :class="!isEnglish ? 'on' : ''" @click="changeLanguage('cn')" class="cn">中</span>/
        <span :class="isEnglish ? 'on' : ''" @click="changeLanguage('en')" class="en">EN</span>
      </div>
      <a-icon class="trigger" type="menu" @click="showDrawer" />
    </div>

    <!-- 
    <a-icon
      class="trigger"
      :type="collapsed ? 'menu-unfold' : 'menu-fold'"
      @click="() => (collapsed = !collapsed)"
    />
    <a-layout-sider v-model="collapsed" :trigger="null" collapsible>
      <a-menu theme="dark" mode="inline" :default-selected-keys="['1']">
        <a-menu-item key="1">
          <a-icon type="user" />
          <span>About us</span>
        </a-menu-item>
        <a-menu-item key="2">
          <a-icon type="video-camera" />
          <span>Services</span>
        </a-menu-item>
        <a-menu-item key="3">
          <a-icon type="upload" />
          <span>Video</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider> -->
    <div class="h_right">
      <a-menu :defaultSelectedKeys="['/main_content']" :selectedKeys="selectedKeys" mode="horizontal" theme="light"
        @click="handleClick">
        <a-menu-item key="/main_content" style="transition-delay: 0ms">
          <span>{{ $t('aboutUs') }}</span>
        </a-menu-item>
        <a-menu-item key="/services" style="transition-delay: 150ms">
          <span>{{ $t('services') }}</span>
        </a-menu-item>
        <!--<a-menu-item key="/video" style="transition-delay: 300ms">
          <span>{{ $t('video') }}</span>
        </a-menu-item>-->
        <a-menu-item key="/resources" style="transition-delay: 450ms">
          <span>{{ $t('resources') }}</span>
        </a-menu-item>
        <a-menu-item key="/team" style="transition-delay: 600ms">
          <span>{{ $t('team') }}</span>
        </a-menu-item>
        <a-menu-item key="/testimonials" style="transition-delay: 750ms">
          <span>{{ $t('testimonials') }}</span>
        </a-menu-item>
        <a-menu-item key="/contact" style="transition-delay: 900ms">
          <span>{{ $t('contactUs') }}</span>
        </a-menu-item>
      </a-menu>
      <div class="language-switch" style="transition-delay: 1050ms">
        <a-select v-model="currentLang" style="width: 100px" @change="changeLanguage">
          <a-select-option value="en">English</a-select-option>
          <a-select-option value="cn">中文</a-select-option>
        </a-select>
      </div>
    </div>
    <a-drawer :placement="placement" :closable="false" :visible="visible" @close="onClose" wrapClassName="sMenu">
      <a-menu mode="inline" :default-selected-keys="['1']" @click="handleDrawerClick">
        <a-menu-item key="/main_content">
          <span>{{ $t('aboutUs') }}</span>
        </a-menu-item>
        <a-menu-item key="/services">
          <span>{{ $t('services') }}</span>
        </a-menu-item>
        <!--<a-menu-item key="/video">
          <span>{{ $t('video') }}</span>
        </a-menu-item>-->
        <a-menu-item key="/resources">
          <span>{{ $t('resources') }}</span>
        </a-menu-item>
        <a-menu-item key="/team">
          <span>{{ $t('team') }}</span>
        </a-menu-item>
        <a-menu-item key="/testimonials">
          <span>{{ $t('testimonials') }}</span>
        </a-menu-item>
        <a-menu-item key="/contact">
          <span>{{ $t('contactUs') }}</span>
        </a-menu-item>
      </a-menu>
    </a-drawer>
  </a-layout-header>
</template>

<script>
export default {
  data() {
    return {
      selectedKeys: ['/main_content'],
      collapsed: false,
      visible: false,
      placement: 'left',
      isEnglish: true,
    };
  },
  methods: {
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    onChange(e) {
      this.placement = e.target.value;
    },
    handleClick({ key }) {
      const currentRoute = this.$route.path;
      if (currentRoute !== key) {
        this.selectedKeys = [key];
        this.$router.push(key);
        const targetSection = document.getElementById(key.slice(1));
        console.log(key.slice(1), targetSection);
        if (targetSection) {
          const headerHeight = document.querySelector('.header').offsetHeight;
          const targetPosition = targetSection.offsetTop - headerHeight;
          this.smoothScroll(targetPosition, 1000); // 1000ms为滚动时间，可调整
        }
      }
    },
    // 添加抽屉菜单点击处理方法
    handleDrawerClick({ key }) {
      this.visible = false;
      this.handleClick({ key });
    },
    smoothScroll(targetY, duration) {
      const startY = window.pageYOffset;
      const distance = targetY - startY;
      let startTime = new Date().getTime();
      const interval = setInterval(() => {
        const currentTime = new Date().getTime();
        const elapsed = currentTime - startTime;
        const progress = elapsed / duration;
        if (progress >= 1) {
          window.scrollTo(0, targetY);
          clearInterval(interval);
        } else {
          window.scrollTo(0, startY + (distance * progress));
        }
      }, 16); // 大约每秒60帧（1000/60 ≈ 16）
    },
    changeLanguage(lang) {
      const currentRoute = this.$route.path;
      this.$i18n.locale = lang;
      this.selectedKeys = [currentRoute];
    }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    $route(to) {
      this.selectedKeys = [to.path];
    },
    currentLang(newLang) {
      this.isEnglish = newLang === 'en';
    }
  },
  mounted() {
    const currentPath = this.$route.path;
    this.selectedKeys = [currentPath];
    const targetSection = document.getElementById(currentPath.slice(1));

    console.log('Route object:', this.$route);
    console.log(currentPath, targetSection);
    this.$nextTick(() => {
      const targetSection = document.getElementById(currentPath.slice(1));
      if (targetSection) {
        const headerHeight = document.querySelector('.header').offsetHeight;
        const targetPosition = targetSection.offsetTop - headerHeight;
        this.smoothScroll(targetPosition, 1000);
      }
    });
  }
  // 删除这里重复的 methods 块
};
</script>

<style scoped lang="less">
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
@mainFontCn: 'Huangchan', sans-serif;

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: end;
  background-color: white;
  height: 110px;

  .logo {
    height: 100%;
    display: flex;
    align-items: center;

    a {
      height: 85%;

      img {
        height: 100%;
        width: auto;
      }
    }
  }

  .h_right {
    display: flex;
    align-items: center;

  }

  .language-switch {}

  .mobile-menu {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4vw;

    .m-language {
      display: none;

      >span {
        display: inline-block;
        min-width: 6vw;
        text-align: center;
        cursor: pointer;
        font-size: 2.5vw;

        &.cn {
          font-family: @mainFontCn;
        }

        &.en {
          font-family: @mainFont;
        }

        &.on {
          color: @mainColor1;
          font-weight: bold;
        }
      }
    }

    .trigger {
      display: none;
      font-size: 1.5rem;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: @mainColor1;
      }
    }
  }

}

// 调整antd菜单样式
.ant-menu-horizontal {
  border: none;

  .ant-menu-item {
    color: @mainColor3;
    border: none;

    &:hover {
      color: @mainColor1;
      border-bottom: 2px solid @mainColor1;
    }
  }

  .ant-menu-item-selected {
    color: @mainColor1;
    border: none;
  }
}

.ant-drawer-body {
  padding: 0 !important;
}

@media all and (max-width: 1115px) {
  .header {
    align-items: center;

    &.ant-layout-header {
      padding: 0 6vw;
    }
  }

  .h_right {
    display: none !important;
  }

  .mobile-menu {
    .m-language {
      display: block !important;
    }

    .trigger {
      display: block !important;
    }
  }
}

@media all and (max-width: 768px) {
  .mobile-menu {
    .trigger {
      display: none !important;
    }
  }
}
</style>
